module.exports = __webpack_public_path__ + "img/Kitchen.be089fce.jpg";